import { locales } from '../locales'
import video from './sample-video.webm?file'
import $style from './style.module.css'

export type WrapperControls = {
    readonly switchOverlayVisibility: (isVisible: boolean) => void
    setContinueAdHandler: (cb: () => void) => void
}

export type WrapperOptions = {
    footerHeight?: string
    locale: keyof typeof locales
}

export function renderInstreamTemplate({ footerHeight = '0px', locale }: WrapperOptions) {
    const wrapper = document.createElement('div')
    wrapper.setAttribute('style', `--footer-height: ${footerHeight};`)
    let continueHandler = () => {}
    const switchOverlayVisibility = (isVisible: boolean) => {
        wrapper.querySelector('[data-id="instream-overlay"]')?.classList.toggle($style.visible, isVisible)
    }
    const updateContinueAdHandler = (cb: () => void) => {
        continueHandler = cb
    }

    wrapper.classList.add($style.wrapper)
    wrapper.insertAdjacentHTML(
        'beforeend',
        `
    <div class="${$style.banner}">
        <video
            data-id="instream-player"
            playsinline
            webkit-playsinline="true"
            class="${$style.player}"
        >
            <source src="${video}" />
        </video>
        <button
             data-id="skip-button"
             class="${$style.skip_button}"
         />
        <button
             data-id="learn-more-button"
             class="${$style.learn_more_button}"
         >
             ${locales[locale]['learnMore']}
         </button>
    </div>
    <div
        data-id="instream-overlay"
        class="${$style.overlay}"
    />`,
    )

    const overlayClickHandler = () => {
        continueHandler()
    }

    wrapper.querySelector('[data-id="instream-overlay"]')?.addEventListener('click', overlayClickHandler)
    return {
        wrapper,
        controls: {
            switchOverlayVisibility,
            setContinueAdHandler: updateContinueAdHandler,
        } as WrapperControls,
    }
}
